import { Game } from './core/Game';

const game = new Game();
game.init().catch((error) => {
  console.error('Failed to initialize game:', error);
});
